import * as React from "react";
const SvgFiRrPooBolt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-poo-bolt_svg__a)">
      <path
        fill="#062147"
        d="M24 18.5c0 3.032-2.468 5.5-5.5 5.5H17a1 1 0 1 1 0-2h1.5c1.93 0 3.5-1.57 3.5-3.5a3.5 3.5 0 0 0-1.813-3.044 1 1 0 0 1-.433-1.271c.163-.377.246-.775.246-1.185a2.98 2.98 0 0 0-1.645-2.657 1 1 0 0 1-.47-1.271q.114-.277.114-.571c0-.827-.673-1.5-1.5-1.5h-.5a1 1 0 0 1-1-1c0-1.211-1.008-2.984-2.101-3.691-.577 3.595-3.448 4.595-3.583 4.64a1 1 0 0 1-.316.052H7.5a1.502 1.502 0 0 0-1.386 2.071 1 1 0 0 1-.47 1.271 2.98 2.98 0 0 0-1.645 2.657c0 .409.083.808.246 1.185a1 1 0 0 1-.433 1.271 3.5 3.5 0 0 0-1.813 3.044c0 1.93 1.57 3.5 3.5 3.5h.5a1 1 0 1 1 0 2h-.5a5.507 5.507 0 0 1-5.5-5.5c0-1.701.803-3.296 2.14-4.329a4.959 4.959 0 0 1 1.895-5.178 3.504 3.504 0 0 1 3.465-3.993h1.306c.482-.222 2.194-1.208 2.194-4a1 1 0 0 1 1-1c2.4 0 4.408 2.747 4.89 5.021a3.505 3.505 0 0 1 3.075 3.972 4.96 4.96 0 0 1 1.895 5.178 5.48 5.48 0 0 1 2.14 4.329zm-6.819-1.554-4.262 6.236a1.85 1.85 0 0 1-1.527.819c-.271 0-.549-.061-.814-.186a1.844 1.844 0 0 1-1.002-2.207l.539-1.622H8.424a1.9 1.9 0 0 1-1.543-.775 1.9 1.9 0 0 1-.297-1.703l2.132-6.174a2 2 0 0 1 1.89-1.348h1.895a2.001 2.001 0 0 1 1.867 2.718l-.453 1.282h1.681a1.903 1.903 0 0 1 1.587 2.959zm-1.733-1.008-2.947.049a1 1 0 0 1-.943-1.333l.933-2.641-1.885-.026-2.083 6.031 2.979-.031a1 1 0 0 1 .95 1.315l-.663 1.992 3.661-5.356z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-poo-bolt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPooBolt;
